var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup5984(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 143,
    viewBox: "0 0 211 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.83 19.6511L87.0389 41.6339C95.0121 58.3939 86.5635 75.2742 81.3425 81.6193L85.2794 93.7931L157.733 125.302L207.782 63.9883L105.83 19.6511Z",
    stroke: "#0A7F69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3343 59.7035C79.7316 53.9438 73.2164 37.9819 68.7841 30.7209C66.8401 28.3986 60.6237 27.7875 57.7584 27.7723L70.3343 59.7035Z",
    fill: "#DBFFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9339 38.5878C31.4125 52.8763 33.4835 83.3097 65.0221 83.2403L80.5227 122.597C81.6925 125.568 86.3635 130.676 95.6886 127.347L96.791 129.057C93.2353 133.459 84.1305 140.905 76.1562 135.468C76.3363 135.054 64.9227 106.582 59.1934 92.3981C40.6399 89.8583 9.66974 75.5412 33.9339 38.5878C33.9769 38.5224 34.02 38.457 34.0633 38.3914L33.9339 38.5878Z",
    fill: "#DBFFF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.718 108.179L89.1392 71.6515C88.3135 71.2862 84.7593 77.9495 83.0854 81.3268L87.2473 92.9831L159.408 123.749L171.718 108.179Z",
    fill: "#DBFFF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3177 6.14398L38.0645 19.2855L46.2328 16.0683L41.0361 3.96194C35.0241 -2.59112 33.3855 2.68619 33.3177 6.14398Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3177 6.14398L38.0645 19.2855L46.2328 16.0683L41.0361 3.96194C35.0241 -2.59112 33.3855 2.68619 33.3177 6.14398Z",
    fill: "url(#paint0_linear_1282_10)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0645 19.2855L33.3177 6.14398C33.3855 2.68619 35.0241 -2.59112 41.0361 3.96194L46.2328 16.0683",
    stroke: "#0A7F69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5238 3.05656L71.663 15.7405L79.7344 19.1936L84.5475 6.92967C84.8773 -1.95726 80.0024 0.64471 77.5238 3.05656Z",
    fill: "url(#paint1_linear_1282_10)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.663 15.7405L77.5238 3.05656C80.0024 0.64471 84.8773 -1.95726 84.5475 6.92967L79.7344 19.1936",
    stroke: "#0A7F69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93107 37.9928L16.515 44.0652L20.1029 36.0529L7.92135 31.0349C-0.958801 30.5562 1.5611 35.474 3.93107 37.9928Z",
    fill: "url(#paint2_linear_1282_10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.515 44.0652L3.93107 37.9928C1.5611 35.474 -0.958801 30.5562 7.92135 31.0349L20.1029 36.0529",
    stroke: "#0A7F69"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1309 83.3978L19.5399 79.4695L16.832 71.1186L4.42849 75.5597C-2.48248 81.1565 2.68386 83.1171 6.1309 83.3978Z",
    fill: "url(#paint3_linear_1282_10)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2514 113.179L45.5733 100.719L37.634 96.9719L32.3744 109.051C31.7189 117.92 36.6859 115.498 39.2514 113.179Z",
    fill: "url(#paint4_linear_1282_10)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.556 77.376L101.082 71.0815L97.3522 79.029L109.443 84.2621C118.313 84.8981 115.881 79.9364 113.556 77.376Z",
    fill: "url(#paint5_linear_1282_10)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.633 32.6497L97.4089 37.1603L100.479 45.3849L112.677 40.4059C119.336 34.5123 114.089 32.7794 110.633 32.6497Z",
    fill: "url(#paint6_linear_1282_10)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5399 79.4695L6.1309 83.3978C2.68386 83.1171 -2.48248 81.1565 4.42849 75.5597L16.832 71.1186",
    stroke: "#0A7F69"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5733 100.719L39.2514 113.179C36.6859 115.498 31.7189 117.92 32.3744 109.051L37.634 96.9719",
    stroke: "#0A7F69"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.082 71.0815L113.556 77.376C115.881 79.9364 118.313 84.8981 109.443 84.2621L97.3522 79.029",
    stroke: "#0A7F69"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4089 37.1603L110.633 32.6497C114.089 32.7794 119.336 34.5123 112.677 40.4059L100.479 45.3849",
    stroke: "#0A7F69"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.187 71.5491C208.727 70.307 208.66 66.2162 207.557 64.5059L157.215 125.077L86.3143 94.2434L88.654 100.184L159.037 130.793C175.195 111.562 207.646 72.7911 208.187 71.5491Z",
    fill: "url(#paint7_linear_1282_10)",
    stroke: "#0A7F69"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2356 53.7405L183.285 92.9013",
    stroke: "#0A7F69"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.518 48.1439L120.819 106.352M136.396 33.7399L88.89 90.6207",
    stroke: "#0A7F69"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3431 81.6196C105.136 42.7922 76.182 27.862 58.8558 25.2504L68.8029 54.52C69.3664 56.178 69.7407 57.9372 69.4233 59.6593C67.3402 70.9648 51.7646 70.4755 48.5015 63.2101L35.5431 33.5742C9.43779 70.9611 40.369 87.5716 59.0978 91.2035C65.2696 105.785 77.7167 134.994 78.1307 135.174C91.2176 137.911 97.5503 129.67 99.0808 125.207C93.0065 110.873 81.1549 82.0875 82.3431 81.6196Z",
    fill: "white",
    stroke: "#0A7F69"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4814 89.967L92.0372 125.836",
    stroke: "#0A7F69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1282_10",
    x1: 29.2146,
    y1: 12.7151,
    x2: 40.5755,
    y2: 26.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1282_10",
    x1: 69.9864,
    y1: 4.84649,
    x2: 68.4779,
    y2: 22.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1282_10",
    x1: 5.59443,
    y1: 45.559,
    x2: 23.2562,
    y2: 47.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1282_10",
    x1: 12.4368,
    y1: 87.8979,
    x2: 26.7536,
    y2: 77.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1282_10",
    x1: 46.8492,
    y1: 111.667,
    x2: 49.0055,
    y2: 94.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1282_10",
    x1: 112.027,
    y1: 69.7815,
    x2: 94.3998,
    y2: 67.6639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1282_10",
    x1: 104.137,
    y1: 28.4295,
    x2: 90.2926,
    y2: 39.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1282_10",
    x1: 87.327,
    y1: 86.3264,
    x2: 145.232,
    y2: 172.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5984);
export default __webpack_public_path__ + "static/media/Group 5984.2875f2a5f318bde6cd66978328d679f2.svg";
export { ForwardRef as ReactComponent };